import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_TRANSACTIONS = "fetchAdminTransactions";
export const DOWNLOAD_ADMIN_TRANSACTIONS = "downloadAdminTransactions";
export const STORE_ADMIN_TRANSACTION = "storeAdminTransaction";

// mutation types
export const SET_ADMIN_TRANSACTIONS = "setAdminTransactions";
export const SET_ADMIN_TRANSACTIONS_PAGINATION =
  "setAdminTransactionsPagination";
export const SET_ADMIN_TRANSACTIONS_PAGINATION_PAGE =
  "setAdminTransactionsPage";
export const SET_ADMIN_TRANSACTIONS_SORT = "setAdminTransactionsSort";

const state = {
  adminTransactions: [],
  adminTransactionsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  sort: {
    col: "id",
    dir: "desc"
  }
};

const getters = {
  adminTransactions(state) {
    return state.adminTransactions;
  },
  adminTransactionsPagination(state) {
    return state.adminTransactionsPagination;
  }
};

const actions = {
  [FETCH_ADMIN_TRANSACTIONS](context, payload = {}) {
    return new Promise((resolve, reject) => {
      payload.page = context.state.adminTransactionsPagination.currentPage;

      ApiService.query("admin/transactions", {
        params: payload
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_TRANSACTIONS, data.data);
          context.commit(SET_ADMIN_TRANSACTIONS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          if (payload.sort && payload.sort.col !== undefined) {
            context.commit(SET_ADMIN_TRANSACTIONS_SORT, payload.sort);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DOWNLOAD_ADMIN_TRANSACTIONS](context, payload = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/transactions/export", {
        params: payload
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_TRANSACTION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/transactions", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_TRANSACTIONS](state, data) {
    state.adminTransactions = data;
  },
  [SET_ADMIN_TRANSACTIONS_PAGINATION](state, data) {
    state.adminTransactionsPagination = data;
  },
  [SET_ADMIN_TRANSACTIONS_PAGINATION_PAGE](state, page) {
    state.adminTransactionsPagination.currentPage = page;
  },
  [SET_ADMIN_TRANSACTIONS_SORT](state, payload) {
    state.sort = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
